<template>
  <main>
    <div class="dealer-content">
      <div style="display: flex; flex-direction: row; justify-content: flex-end;">
        <button class="dealer-btn" @click="handleCompMode('dealer')">Dealer</button>
        <button class="territory-btn" @click="handleCompMode('territory')">Territory</button>
      </div>
      <div v-if="CompMode === 'dealer'">
        <DealerComp />
      </div>
      <div v-if="CompMode === 'territory'">
        <TerritoryComp />
      </div>
    </div>
  </main>
</template>

<script>
import DealerComp from '@/components/dealer_editor/DealerComp.vue';
import TerritoryComp from '@/components/dealer_editor/TerritoryComp.vue';
import { useDealerStore } from '@/store/DealerStore.js';
import { useTerritoryStore } from '@/store/TerritoryStore';
import gsap from 'gsap';
export default {
  setup () {
    const dealerStore = useDealerStore();
    const territoryStore = useTerritoryStore();
    dealerStore.fetchDealers();
    territoryStore.fetchRegions();

  },
  data () {
    return {
      compMode: 'dealer'
    };
  },
  components: {
    DealerComp,
    TerritoryComp
  },
  computed: {
    CompMode () {
      return this.compMode;
    }
  },
  methods: {
    handleCompMode (mode) {
      if (mode === 'dealer') {
        gsap.to('.dealer-btn', {
          color: '#ffffff',
          backgroundColor: '#0089d0'
        });
        gsap.to('.territory-btn', {
          color: 'black',
          backgroundColor: 'white'
        });
      } else {
        gsap.to('.territory-btn', {
          color: '#ffffff',
          backgroundColor: '#0089d0'
        });
        gsap.to('.dealer-btn', {
          color: 'black',
          backgroundColor: 'white'
        });
      }
      this.compMode = mode;
    }
  }
};
</script>
<style scoped>
.dealer-content {
  display: flex;
  flex-direction: column;
  /* align-items: center;
  justify-content: center; */
}
.territory-content {
  display: flex;
  /* align-items: center;
  justify-content: center; */
}
.dealer-btn {
  background-color: #0089d0;
  color: #fff;
  padding: 10px;
}
.territory-btn {
  padding: 10px; 
  margin-right: 15px;
}
</style>